import { render, staticRenderFns } from "./LookupSuburb.vue?vue&type=template&id=1266e3ca&scoped=true"
import script from "./LookupSuburb.vue?vue&type=script&lang=ts"
export * from "./LookupSuburb.vue?vue&type=script&lang=ts"
import style0 from "./LookupSuburb.vue?vue&type=style&index=0&id=1266e3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1266e3ca",
  null
  
)

export default component.exports